import React, {useEffect, useState} from 'react';
import {Spotlight} from "types/Spotlight";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props<T extends Spotlight> = {
    spotlight: T | null
    show: boolean
    onDelete?: (spotlight: T) => any
    onDeleteFail?: (spotlight: T, error: unknown) => any
    onCancel?: () => any
}

function DeleteSpotlight<T extends Spotlight>(props: Props<T>) {
    const {spotlight, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(spotlight?.name || 'this spotlight');
    const {mutateAsync: deleteSpotlight} = useMutation(ngage.spotlights.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if (spotlight) setName(spotlight.name)
    }, [spotlight]);

    async function handleDeleteSpotlight() {
        if (spotlight) {
            try {
                await deleteSpotlight(spotlight.id)
                await invalidate('spotlights.all')

                notify("success", "Spotlight Deleted", `${spotlight.title} has been permanently removed`)
                if (onDelete) onDelete(spotlight)
            } catch (error) {
                notify("error", "Spotlight Not Deleted", `${spotlight.title} could not be removed`)
                if (onDeleteFail) onDeleteFail(spotlight, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Spotlight"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteSpotlight}
            onCancel={handleCancel}
        />
    );
}

export default DeleteSpotlight;